import React from 'react';
import { formatDisplayDate, formatPrice, slotLabel } from '../../../utils/labTestUtils';

export default function ReviewPayStep({
  selectedPatient,
  selectedSku,
  selectedSlot,
  appointmentDate,
  address,
  walletBalanceMinorUnits,
  insufficientWalletBalance,
}) {
  const priceRupees = selectedSku?.rate?.sellingPrice ?? selectedSku?.rate?.listingPrice ?? 0;
  const balanceRupees = walletBalanceMinorUnits !== null ? walletBalanceMinorUnits / 100 : null;

  return (
    <div className="form-section fade-in-up delay-4">
      <div className="form-section-title">
        <span className="lab-step-badge is-done">4</span>
        Review &amp; pay
      </div>
      <div className="form-section-subtitle">
        {/* 27 Jul 2026: was "You will complete payment securely via Razorpay." —
            Deepu's explicit direction, 27 Jul 2026: navigator bookings are
            wallet-only, no Razorpay. */}
        Confirm the details below. The amount will be charged to the patient's Previu wallet.
      </div>

      {/* 27 Jul 2026: new — proactive wallet balance / insufficient-funds
          notice. Balance now comes from the centralized state in
          useLabTestBooking.js (also shown in the always-visible Order
          Summary sidebar and used to disable the submit button) rather
          than a separate fetch here — three places showing the same value
          from one source, not three independently-fetched copies that
          could drift out of sync with each other. */}
      {walletBalanceMinorUnits !== null && (
        <div style={{
          marginTop: 10, marginBottom: 4, padding: '10px 14px',
          borderRadius: 'var(--radius-sm)',
          background: insufficientWalletBalance ? 'var(--red-bg)' : 'var(--blue-bg)',
          border: `1px solid ${insufficientWalletBalance ? 'var(--red)' : 'var(--brand-blue)'}`,
          fontSize: 13, fontWeight: 600,
          color: insufficientWalletBalance ? 'var(--red)' : 'var(--brand-blue)',
        }}>
          Patient wallet balance: ₹{balanceRupees.toLocaleString('en-IN')}
          {insufficientWalletBalance && (
            <> — insufficient for this ₹{priceRupees.toLocaleString('en-IN')} order.
              Ask the patient to add money to their wallet before proceeding.</>
          )}
        </div>
      )}

      <div className="lab-review-grid">
        <div className="lab-review-item">
          <div className="lab-review-label">Patient</div>
          <div className="lab-review-value">
            {selectedPatient.firstName} {selectedPatient.lastName}
          </div>
          <div className="lab-review-meta">{selectedPatient.phone}</div>
        </div>
        <div className="lab-review-item">
          <div className="lab-review-label">Test plan</div>
          <div className="lab-review-value">{selectedSku.name}</div>
          <div className="lab-review-meta">
            {selectedSku.noOfTestsIncluded} tests · {formatPrice(selectedSku.rate)}
          </div>
        </div>
        <div className="lab-review-item">
          <div className="lab-review-label">Appointment</div>
          <div className="lab-review-value">{formatDisplayDate(appointmentDate)}</div>
          <div className="lab-review-meta">{slotLabel(selectedSlot)} · Asia/Kolkata</div>
        </div>
        <div className="lab-review-item">
          <div className="lab-review-label">Collection address</div>
          <div className="lab-review-value">
            {[address.addressLine1, address.city, address.state].filter(Boolean).join(', ')}
          </div>
          <div className="lab-review-meta">PIN {address.pincode}</div>
        </div>
      </div>

      <div className="lab-summary-total" style={{ borderRadius: 'var(--radius-sm)', marginTop: 4 }}>
        <div className="lab-summary-total-label">Amount due</div>
        <div className="lab-summary-total-amount">{formatPrice(selectedSku.rate)}</div>
      </div>
    </div>
  );
}
